import React, { useState, useEffect, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import strings from "translate/language";
import { useDispatch, useSelector } from "react-redux";
import { forgotPassword } from "reduxStore/action/authActions";
import { emailAddressValid, seo } from "utils/utils";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [forgotDetail, setForgotDetail] = useState({});
  const [errorMessage, setErrorMessage] = useState({});

  const dispatch = useDispatch();
  const forgotPasswordSelector =
    useSelector((state) => state.forgotPassword) || {};

  const forgotUser = async () => {
    const { response, otpSend = false } = forgotPasswordSelector || {};
    if (response && otpSend) {
      if (response?.status === 200) {
        navigate("/verifyotp");
      }
    }
  };
  const handleEnterPress = (event) => {
    // console.log('User pressed: ', event.key);

    // console.log(message);

    if (event.key === "Enter") {
      // 👇️ your logic here
      event.preventDefault();
      // console.log('Enter key pressed ✅');
      Verifyotp();
    }
  };
  useEffect(() => {
    forgotUser();
  }, [forgotPasswordSelector]);

  const validation = () => {
    let isError = true;
    let errorMessage = {};

    if (forgotDetail.email == undefined || forgotDetail.email === "") {
      isError = false;
      errorMessage["email"] = strings.emailRequire;
    } else if (!emailAddressValid(forgotDetail.email)) {
      isError = false;
      errorMessage["email"] = strings.emailValidationErr;
    }

    setErrorMessage(errorMessage);
    return isError;
  };
  const Verifyotp = () => {
    if (validation()) {
      dispatch(forgotPassword(forgotDetail));
    }
  };
  useEffect(() => {
    seo({
      title: "Forgot Password",
      metaDescription: "Forgot password",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <Fragment>
      <div className="page-wrapper">
        <div className="container-fluid p-0">
          {/* login page start*/}
          <div className="authentication-main">
            <div className="row">
              <div className="col-md-12">
                <div className="auth-innerright">
                  <div className="authentication-box">
                    <div className="text-center">
                      <img
                        className="login-logo"
                        src="/assets/images/JUSTOLOGO.jpg"
                        alt=""
                      />
                    </div>
                    <div className="card mt-4">
                      <div className="card-body">
                        <div className="text-center">
                          <h4>{strings.forgotpass}</h4>
                          <h6>{strings.enterEmailForResetPass}</h6>
                        </div>
                        <form className="theme-form">
                          <div>
                            <label className="col-form-label pt-0">
                              {strings.yourEmail}
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              onChange={(e) =>
                                setForgotDetail({
                                  ...forgotDetail,
                                  email: e.target.value,
                                })
                              }
                              onKeyDown={handleEnterPress}
                              required=""
                            />
                            {errorMessage.email && (
                              <span style={{ color: "red" }}>
                                {errorMessage.email}
                              </span>
                            )}
                          </div>
                          <div className="col-form-label pt-3 pb-0">
                            <label
                              onClick={() => navigate("/")}
                              className="text-primary forgot_pass"
                              style={{ fontWeight: "bold" }}
                            >
                              {"<< "}
                              {strings.backToLogin}
                            </label>
                          </div>
                          <div className="form-group form-row mt-3 mb-0 d-flex justify-content-center">
                            <button
                              onClick={() => Verifyotp()}
                              className="btn btn-primary px-5"
                              type="button"
                            >
                              {strings.sendOTP}
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* login page end*/}
        </div>
      </div>
    </Fragment>
  );
};

export default ForgotPassword;
